import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _BoxCutBase extends BaseCssVarValue {
  abstract cssType: 'default'
  /** 裁剪盒子宽度 */
  ['--box-cut-width']?: string;
  /** 裁剪盒子高度 */
  ['--box-cut-height']?: string;
  /** 裁剪盒子圆角 */
  ['--box-cut-border-radius']?: string;
  /** 裁剪盒子(虚拟)边框宽度 */
  ['--box-cut-border-width']?: string;
  /** 裁剪盒子的边框颜色 */
  ['--box-cut-border-color']?: string;
  /** 裁剪盒子的阴影 */
  ['--box-cut-box-shadow']?: string
}
